/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation CustomerUpdateMutation(
  $customerId: ID!,
  $type: CUSTOMER_TYPE,
  $companyName: String,
  $invoiceName: String!,
  $companyReferenceNumber: String,
  $country: String,
  $companyEmail: EmailAddress,
  $supportEmail: EmailAddress,
  $billingEmail: [EmailAddress],
  $rateEmail: [EmailAddress],
  $billingAddress: String,
  $currency: String,
  $billingPeriod: BILLING_PERIOD,
  $phone: String,
  $smsType: String,
  $entityToBill: String,
  $overDraftLimit: Float
  $alertAmount: Float,
  $enableAutoInvoicing: Boolean
) {
  CustomerUpdate(
    customerId: $customerId,
    type: $type,
    companyName: $companyName,
    invoiceName: $invoiceName,
    companyReferenceNumber: $companyReferenceNumber,
    country: $country,
    companyEmail: $companyEmail,
    supportEmail: $supportEmail,
    billingEmail: $billingEmail,
    rateEmail: $rateEmail,
    entityToBill: $entityToBill,
    billingAddress: $billingAddress,
    currency: $currency,
    billingPeriod: $billingPeriod,
    phone: $phone,
    smsType: $smsType,
    overDraftLimit: $overDraftLimit,
    alertAmount: $alertAmount,
    enableAutoInvoicing: $enableAutoInvoicing
  ) {
    message
    status
  }
}
`
